import { ICustomModal } from "../interfaces/app_types";
import React from "react";

const CustomModal = ({
  modalBody,
  modalTitle,
  modalId = "exampleModal",
}: ICustomModal) => {
  return (
    <React.Fragment>
      <div
        className="modal fade"
        id={modalId}
        data-modal-class="true"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby={`${modalId}Label`}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id={`${modalId}Label`}>
                {modalTitle}
              </h1>
              <button
                type="button"
                className={`btn-close ${modalId}-modal-btn-close`}
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body overflow-auto">{modalBody}</div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CustomModal;
